import { lazy } from "react";
import Loadable from "app/components/Loadable";
import AuthGuard from "app/auth/AuthGuard";

const ChooseAccount = Loadable(lazy(() => import("./ChooseAccount")));
const ConfirmEmail = Loadable(lazy(() => import("./ConfirmEmail")));
const EmailRegistrationForm = Loadable(lazy(() => import("./EmailRegistrationForm")));
const Loading = Loadable(lazy(() => import("./Loading")));

const sessionRoutes = [
  {
    path: "/choose-account",
    element: (
      <AuthGuard>
        <ChooseAccount />
      </AuthGuard>
    ),
  },
  {
    path: "/confirm-email",
    element: (
      <AuthGuard>
        <ConfirmEmail />
      </AuthGuard>
    ),
  },
  {
    path: "/register",
    element: (
      <EmailRegistrationForm />
    ),
  },
  {
    path: "/loading",
    element: (
      <Loading />
    ),
  },
];

export default sessionRoutes;
